import * as React from 'react';
import { Create, SimpleForm, TextInput, ImageInput, ImageField, NumberInput } from 'react-admin';

export const TelegramProductCreate: React.FC = () => (
  <Create>
    <SimpleForm>
      <TextInput source="title" style={{ width: '400px' }} />
      <TextInput source="description" style={{ width: '400px' }} />
      <NumberInput source="price" />
      <ImageInput source="image" label="Upload Image" accept="image/*">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Create>
);
